
import crud from "./_crud";
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud('client_group', 'el grupo de cliente', 'los grupos de cliente');

const importClientsGroups = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/client_group/import_clients_groups`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: `Se agreron los grupos de clientes correctamente.`,
		})
		showSuccessMessage('Se registraron los grupos de clientes correctamente')
		return res.body
	}
}

export default {...actions, importClientsGroups}